import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ThemeProvider } from "@material-ui/styles";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import { CssBaseline, createMuiTheme } from "@material-ui/core";
import { Container, Box } from "@material-ui/core";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      access_token: localStorage.getItem("spotify_auth_access_token"),
    };
  }

  handleLogout = () => {
    this.setState({ access_token: null });
  };

  handleLogin = (access_token) => {
    this.setState({ access_token: access_token });
  };

  render() {
    const { access_token } = this.state;
    const theme = createMuiTheme({
      palette: {
        type: "dark",
        primary: {
          main: "#1DB954",
        },
      },
      overrides: {
        MuiButton: {
          contained: { "&:hover": { color: "#000000" } },
        },
        MuiIconButton: { root: { "&:focus": { outline: "none" } } },
      },
    });

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container>
          <Box mt={4}>
            <Router>
              <Route
                path="/"
                render={(props) =>
                  !access_token ? (
                    <Login handleLogin={this.handleLogin} {...props} />
                  ) : (
                    <Dashboard
                      currentNavigation={"AlbumsToRate"}
                      handleLogout={this.handleLogout}
                    />
                  )
                }
              />
            </Router>
          </Box>
        </Container>
      </ThemeProvider>
    );
  }
}

export default App;
